/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventssearchplaceholder2Inputs */

const en_eventssearchplaceholder2 = /** @type {(inputs: Eventssearchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title, description or place`)
};

const de_eventssearchplaceholder2 = /** @type {(inputs: Eventssearchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel, Beschreibung oder Ort`)
};

/**
* | output |
* | --- |
* | "Title, description or place" |
*
* @param {Eventssearchplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventssearchplaceholder2 = /** @type {((inputs?: Eventssearchplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventssearchplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventssearchplaceholder2(inputs)
	return de_eventssearchplaceholder2(inputs)
});
export { eventssearchplaceholder2 as "eventsSearchPlaceholder" }